import React, { useState } from 'react'
import { Helmet } from 'react-helmet'
import TopNavigation from '../Components/navigation/TopNavigation'
import { motion } from "framer-motion";
import { useRef } from "react";
import { useInView } from "framer-motion";
import MainFooter from '../Components/footer/MainFooter';
import { FaPlayCircle } from 'react-icons/fa';

function HowTo() {
    const cardsRef                      = useRef(null);
    const isInView                      = useInView(cardsRef, { once: true, margin: "-20px" });
    
    const [isPlaying, setIsPlaying]     = useState(false);
    const steps = [
        "Make payment by clicking on the Pay Now button on the onvite page.",
        "Once payment is succesful, you may create an onvite with the create onvite button that will appear after payment.",
        "Add the main event details, which would be the wedding ceremony, then add the reception details if any.",
        "If needed you may add the contact person. This will be the contact person to contact especially on the day for anything.",
        "Add the couple details and the invitation message.",
        "Make updates to your onvite on your profile page under the Onvite tab."
    ];

      const container = {
        hidden: {},
        visible: {
        transition: {
            staggerChildren: 0.3 // Delay between cards
        }
        }
    };

    const card = {
        hidden: { opacity: 0, x: 50 },
        visible: { opacity: 1, x: 0, transition: { duration: 0.6, ease: "easeOut" } }
    };

    const handlePlay = () => {
        setIsPlaying(true);
    };

   return (
    <div className="main-layer">
      <Helmet>
              <title>Lovedripp - How to </title>
      </Helmet>
      
       <TopNavigation title={"How to"} classBack="full-white"/>
       <div className="content-layer">
          <div className="section-item">
              <div className="container">
                  <div className="short-style-banner">
                    <div className="head-container-widget">
                      <h2>How to</h2>
                      <div className="sub-head-widget">
                      Check out the steps to do something on Lovedripp
                      </div>
                    </div>
                  </div>
              </div>
          </div>
          <div className="section-item mgbot60">
             <div className="container">
                <h3 className="text-center">How to create an onvite for yourself</h3>
                <motion.div
                ref={cardsRef}
                className="grid-cards"
                variants={container}
                initial="hidden"
                animate={isInView ? "visible" : "hidden"}
                >
                    {steps.map((text, index) => (
                        <motion.div key={index} className="steps-cards" variants={card}>
                        <div className="step-num">STEP - {String(index + 1).padStart(2, "0")}</div>
                        <div className="info-step">{text}</div>
                        </motion.div>
                    ))}
                </motion.div>
             </div>
          </div>
          <div className="section-item mgbot60">
             <div className="container">
                <div className="video-channel-container">
                    <motion.div
                            className={`video-play ${!isPlaying ? "small-view" : ""}`}
                            animate={{
                                width: isPlaying ? "100%" : "300px",
                                right: isPlaying ? "0px" : "10px",
                                top: isPlaying ? "0px" : "auto",
                                }}
                            transition={{ duration: 0.6, ease: "easeInOut" }}
                            >
                        <video 
                            className="vid-element"
                            controls={isPlaying}
                            autoPlay={isPlaying}>
                            <source src="https://lovedripp.co.za/assets/videos/Lovedripp-onvite-create.mp4" type="video/mp4" />
                        </video>
                    </motion.div> 
                    <div className="text-play-video">
                        Check out the video on how to create an <span>Onvite</span> for your up and coming <i>wedding</i>.
                    </div>
                    <button className="btn btn-player" onClick={handlePlay}>
                        <FaPlayCircle />
                    </button>
                </div>
             </div>
          </div>
          <div className="section-item">
            <div className="container">
                <div className="row">
                    <div className="col-md-8">
                        <div className="video-block-low">
                            <video 
                                className="vid-element"
                                controls={true}
                                autoPlay={false}>
                                <source src="https://lovedripp.co.za/assets/videos/Onsite-edit-invite.mp4" type="video/mp4" />
                            </video>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="text-play-video">
                            How to Edit your Onsite
                        </div>
                    </div>
                  
                </div>
            </div>
          </div>
          <div className="section-item">
            <div className="container">
                <div className="row">
                                        
                    <div className="col-md-4">
                        <div className="text-play-video size-min2">
                            How to add onsite images from your proposal.
                        </div>
                    </div>
                    <div className="col-md-8">
                        <div className="video-block-low">
                                <video 
                                    className="vid-element"
                                    controls={true}
                                    autoPlay={false}>
                                    <source src="https://lovedripp.co.za/assets/videos/Onsite-proposal.mp4" type="video/mp4" />
                                </video>
                        </div>
                    </div>
                </div>
            </div>
          </div>
        </div>
         <MainFooter />
    </div>
  )
}

export default HowTo